import React, { useState } from "react";
import HeaderLogo from "../../assets/img/src/timebooth_typo--s.png";
import SearchIcon from "@material-ui/icons/Search";
import ScheduleIcon from "@material-ui/icons/Schedule";
// import { IconButton } from "@material-ui/core";
import { animateScroll as scroll } from "react-scroll";
import { DrawerMenu } from ".";
import "../../assets/css/header.css";
import { AleartModal } from "../UIkit";

const scrollToTop = () => {
  scroll.scrollToTop();
};

const HeaderMenu = (props) => {
  const [openA, setOpenA] = useState(false);
  const [openB, setOpenB] = useState(false);

  const handleOpenA = () => {
    setOpenA(true);
  };
  const handleCloseA = () => {
    setOpenA(false);
  };
  const handleOpenB = () => {
    setOpenB(true);
  };
  const handleCloseB = () => {
    setOpenB(false);
  };

  return (
    <>
      <div className="header-container">
        <div className="header-container--inner">
          <div className="flex-row">
            <img className="logo-title hover1" src={HeaderLogo} alt="ロゴ画像" onClick={scrollToTop} />
            <div className="header-icon flex-row--justright hover1 header-icon-adjust ">
              <SearchIcon style={{ fontSize: 20 }} onClick={handleOpenA} />
              <AleartModal
                title="検索機能"
                text="準備中です"
                open={openA}
                handleClose={handleCloseA}
                onClick={handleCloseA}
              />
            </div>

            <div className="header-icon hover1 header-icon-adjust ">
              <ScheduleIcon style={{ fontSize: 20 }} onClick={handleOpenB} />
              <AleartModal
                title="スケジュール表示機能"
                text="準備中です"
                open={openB}
                handleClose={handleCloseB}
                onClick={handleCloseB}
              />
            </div>

            <div className="header-rightーadjust">
              <DrawerMenu fontSize={20} isLoginPage={props.isLoginPage} />
            </div>
          </div>
        </div>
      </div>
      <div className="header-container--foundation"></div>
    </>
  );
};

export default HeaderMenu;
